import { create } from 'zustand';

type AlertType = 'alert' | 'confirm';

interface AlertState {
  open: boolean;
  type: AlertType;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  resolver: ((value: boolean) => void) | null;
  openAlert: (params: {
    type: AlertType;
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    resolver?: (value: boolean) => void;
  }) => void;
  resolve: (value: boolean) => void;
}

export const useAlertsStore = create<AlertState>()((set, get) => ({
  open: false,
  type: 'alert',
  title: 'Notice',
  message: '',
  confirmText: 'OK',
  cancelText: 'Cancel',
  resolver: null,

  openAlert: ({ type, title, message, confirmText, cancelText, resolver }) =>
    set({
      open: true,
      type,
      title: title ?? (type === 'confirm' ? 'Confirm' : 'Notice'),
      message,
      confirmText: confirmText ?? (type === 'confirm' ? 'OK' : 'OK'),
      cancelText: cancelText ?? 'Cancel',
      resolver: resolver ?? null,
    }),

  resolve: (value) => {
    const resolver = get().resolver;
    if (resolver) resolver(value);
    set({
      open: false,
      type: 'alert',
      title: 'Notice',
      message: '',
      confirmText: 'OK',
      cancelText: 'Cancel',
      resolver: null,
    });
  },
}));
